import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import querystring from "query-string";
export const useQueryStringParams = () => {
    const { search } = useLocation();
    return useMemo(() => querystring.parse(search), [search]);
};
//# sourceMappingURL=useQueryStringParams.js.map